import {noMinimumTest} from './constants/signalmanConstants';

export default function noMinimumTestEnabled() {
  return noMinimumTest === 'test';
}
